import { jsx as _jsx } from "react/jsx-runtime";
import { Portal } from '@kubit/web-ui-components/portal';
import * as React from 'react';
import { ModalContainerControlled } from './modalContainerControlled';
const ModalContainerComponent = ({ portalId, ...props }, ref) => {
    const [open, setOpen] = React.useState(props.open);
    React.useEffect(() => {
        if (props.open !== undefined) {
            setOpen(props.open);
        }
    }, [props.open]);
    const handleCloseInternally = () => {
        setOpen(false);
        props.popover?.onCloseInternally?.();
        props.onCloseInternally?.();
    };
    const modalStructure = (_jsx(ModalContainerControlled, { ...props, ref: ref, open: open, popover: {
            ...props.popover,
            onCloseInternally: handleCloseInternally,
        }, onCloseInternally: () => setOpen(false) }));
    return portalId ? _jsx(Portal, { wrapperId: portalId, children: modalStructure }) : modalStructure;
};
ModalContainerComponent.displayName = 'ModalContainerComponent';
const ModalContainer = React.forwardRef(ModalContainerComponent);
export { ModalContainer };
//# sourceMappingURL=modalContainerUnControlled.js.map